/* RESPONSIBLE TEAM: team-actions */
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';
import type SetupAction from 'embercom/models/workflow-connector/setup-action';
import type ArrayProxy from '@ember/array/proxy';
import type McpActions from 'embercom/models/workflow-connector/mcp-actions';
export default class CustomActions extends SettingsRoute {
  @service declare store;
  @service declare appService: $TSFixMe;
  @service declare intercomEventService;
  @service declare permissionsService: $TSFixMe;
  @service declare intl: IntlService;

  analytics = {
    section: 'settings',
    place: 'action-builder',
  };

  get titleToken() {
    return this.intl.t('new-settings.app-settings.custom-actions.action-builder-title');
  }

  async model() {
    if (this.appService.app.canUseMcpActions) {
      let mcpActions: ArrayProxy<McpActions> = await this.store.query(
        'workflow-connector/mcp-actions',
        {},
      );

      return {
        mcpActions,
        templateActions: [], // Template actions are handled within mcpServers
        actions: [], // For backwards compatibility
      };
    } else {
      let actions: ArrayProxy<SetupAction> = await this.store.query(
        'workflow-connector/setup-action',
        {},
      );

      if (!actions) {
        return {
          actions: [],
          templateActions: [],
          mcpActions: [],
        };
      }

      let workflowActions = actions.filterBy('isTemplate', false);
      let templateActions = actions.filterBy('isTemplate', true);

      return {
        actions: workflowActions,
        templateActions,
        mcpActions: [],
      };
    }
  }

  @action
  didTransition() {
    super.didTransition();
    this.intercomEventService.trackEvent('has_visited_custom_actions');
  }
}
